import { useNavigate, useSearchParams } from "react-router-dom";
import Layout from "../component/Layout";
import SubLayout from "../component/SubLayout";
import classes from "./SubscribePage.module.css";
import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { FaCheck, FaCopyright } from "react-icons/fa6";
import { v4 as uuidv4 } from "uuid";
import SmallLoader from "../component/SmallLoader";
import Header from "../component/Header";
import Container from "../component/Container";
import { loginApi, getPacksApi, subApi, getSubStatusApi } from "../http/http";
import { service, serviceDetail, isValidUrl } from "../utils/constant";
import { setUserDetails } from "../store/slices/userSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const SubscribePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [msisdn, setMsisdn] = useState(
    searchParams.get("mn") ? searchParams.get("mn") : "",
  );
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [extRef, setExtRef] = useState(null);
  const [userId, setUserId] = useState();
  const [selectedPack, setSelectedPack] = useState(1);
  const [packs, setPacks] = useState([
    { id: 1, packCurrency: "TSH", packFrequency: "Daily", packPrice: 300 },
    { id: 2, packCurrency: "TSH", packFrequency: "Weekly", packPrice: 700 },
    { id: 3, packCurrency: "TSH", packFrequency: "Monthly", packPrice: 1500 },
  ]); // State to store packs data
  const [flow, setFlow] = useState(""); // State to track flow
  const [flowMsg, setFlowMsg] = useState({ number: "0", error: true });
  const { selectedLanguage } = useSelector((state) => state.languageSlice);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { userDetails } = useSelector((state) => state?.persisted?.userSlice);

  /* useEffect(() => {
    if (searchParams.get("id")) {
      setUserId(searchParams.get("id"));
    }
    if (searchParams.get("ext_ref")) {
      setExtRef(searchParams.get("ext_ref"));
    } else {
      setSearchParams({ ext_ref: uuidv4() });
    }
  }, [searchParams]);
*/
  useEffect(() => {
    if (userDetails?.token) {
      navigate("/home");
    } else {
      setPageLoading(true);
      getPacksApi(searchParams.get("id") ? searchParams.get("id") : null)
        .then((res) => {
          setPageLoading(false);
          //console.log("All packs ", res?.data);
          setPacks(res?.data); // Set packs data
          if (res?.events) {
            setMsisdn(res?.events?.msisdn);
            if (res?.participant) {
              setFlow("EXISTING");
              if (res.participant === 1) {
                dispatch(setUserDetails(res?.events));
                window.location.href = "/home";
              } else if (res.participant === 2) {
                setFlowMsg({ number: "lowbalance", error: true }); //low balance;
              } else if (res.participant === 0) {
                setFlowMsg({ number: "inprocess", error: true }); //Charging in process;
              } else {
                dispatch(setUserDetails(res?.events));
                window.location.href = "/home";
              }
            } else {
              dispatch(setUserDetails(res?.events));
              window.location.href = "/home";
            }
          } else setFlow("PACK"); // select pack
        })
        .catch((err) => {
          setPageLoading(false);
          console.log(err);
        });
    }
  }, []);

  const checkSubStatus = async (input) => {
    console.log("input=" + input);
    if (msisdn.length >= 8) {
      setLoading(true);
      await getSubStatusApi({ mobileNumber: parseInt(msisdn) })
        .then((res) => {
          setFlow("EXISTING");
          if (res.responseCode === 200) {
            dispatch(setUserDetails(res?.data));
            if (input === "1") {
              window.location.href = "/home";
            } else setFlowMsg({ number: "alreadySub", error: false }); //already sub and charged ;
          } else if (res.responseCode === 203)
            setFlowMsg({ number: "lowbalance", error: true }); //low balance;
          else if (res.responseCode === 202)
            setFlowMsg({ number: "inprocess", error: true }); //Charging in process;
          else setFlow("PACK"); // select pack
        })
        .catch((err) => {
          console.log(err);
          toast.error(t("128"));
        })
        .finally(() => setLoading(false));
    } else {
      toast.error(t("invalidNumber"));
    }
  };

  const handleFormSubmission = async (e) => {
    e.preventDefault();
    if (msisdn?.trim().length === 0) {
      return;
    }
    setLoading(true);
    await subApi({
      mobileNumber: msisdn,
      packId: selectedPack,
      languageId: String(selectedLanguage),
    })
      .then((res) => {
        setLoading(false);
        if (res?.responseCode === 202) {
          // already subscribed and charged
          setFlow("EXISTING");
          setFlowMsg({ number: "alreadySub", error: false }); //New subscription;
          //dispatch(setUserDetails(res?.data));
          //window.location.href = "/home";
        } else {
          if (res?.data && isValidUrl(res?.data)) {
            setFlow("REDIRECT");
            window.location.href = res.data;
          } else {
            setFlow("EXISTING");
            setFlowMsg({ number: "subSuccess", error: false }); //New subscription;
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.error(t("128"));
      });
  };

  return pageLoading ? (
    <SmallLoader style={{ border: "5px solid #fff" }} />
  ) : (
    <Layout>
      <SubLayout>
        <Header hide={true} />

        <Container>
          <h1 className={classes.heading}>
            <span className={classes.highlight}>{t("0")} </span>
            {t("1")}
          </h1>
          <div className={classes.actions_box_container}>
            <div className={classes.actions_box}>
              <button
                className={`${classes.action_box}`}
                type="button"
                onClick={() =>
                  navigate(`/login?mn=${msisdn}&ext_ref=${extRef}`)
                }
              >
                {t("2")}
              </button>
              <button className={`${classes.action_box} ${classes.active}`}>
                {t("3")}
              </button>
            </div>
          </div>
          {flow === "EXISTING" ? (
            <>
              <h3
                className={`mb-3 mt-3 text-center login-title-${flowMsg.error ? "red" : "green"}`}
              >
                {t(flowMsg.number)}
              </h3>

              <button
                disabled={loading}
                onClick={() => checkSubStatus("1")}
                className={classes.login_btn}
              >
                {loading ? (
                  <SmallLoader style={{ border: "5px solid #fff" }} />
                ) : (
                  t("137")
                )}
              </button>
            </>
          ) : flow === "REDIRECT" ? (
            <>
              <h3 className={`mb-3 mt-3 text-center login-title-green`}>
                {t("redirect")}
              </h3>
            </>
          ) : (
            <form className={classes.form} onSubmit={handleFormSubmission}>
              <div className={classes.username_field_form}>
                <div className={classes.country_code}>
                  <img
                    src={
                      "/assets/images/" + serviceDetail[service]?.flag + ".svg"
                    }
                    //src={"https://flagcdn.com/" + serviceDetail[service]?.flag + ".svg"}
                    alt="flag"
                    className={classes.flag}
                  />
                  <p className={classes.country_code_number}>
                    +{serviceDetail[service]?.countryCode}
                  </p>
                </div>

                <input
                  id="msisdn"
                  name="msisdn"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  autoFocus
                  placeholder={t("4")}
                  className={classes.input_field_username}
                  onChange={(e) => {
                    setMsisdn(
                      e.target.value && e.target.value.trim().length <= 10
                        ? e.target.value.trim()
                        : e.target.value.trim().slice(0, 10),
                    );
                  }}
                  value={
                    msisdn && msisdn.trim().length > 10
                      ? msisdn.trim().slice(3)
                      : msisdn
                  }
                />
              </div>

              <div className={classes.packs}>
                <p className={classes.packs_heading}>{t("5")}</p>
                {packs.map((pack) => (
                  <button
                    key={"b" + pack.id}
                    type="button"
                    className={`${classes.pack_box} ${selectedPack === pack.id ? (selectedPack === 1 ? classes.shade_blue : selectedPack === 2 ? classes.shade_green : classes.shade_red) : ""}`}
                    onClick={() => setSelectedPack(pack.id)}
                  >
                    <span
                      key={"s" + pack.id}
                      className={`${classes.pack_header} ${selectedPack === pack.id ? (selectedPack === 1 ? classes.shade_blue : selectedPack === 2 ? classes.shade_green : classes.shade_red) : ""}`}
                    >
                      {t("pack" + pack.id + "_1")}
                    </span>
                    {selectedPack === pack.id ? (
                      <div
                        key={"d" + pack.id}
                        className={`${classes.checked_radio} ${selectedPack === 1 ? classes.shade_blue : selectedPack === 2 ? classes.shade_green : classes.shade_red}`}
                      >
                        <FaCheck
                          key={"f" + pack.id}
                          className={classes.checked_icon}
                        />
                      </div>
                    ) : (
                      <div
                        key={"d1" + pack.id}
                        className={classes.dummy_radio}
                      ></div>
                    )}
                    <p
                      key={"p" + pack.id}
                      className={`${classes.pack_price_point} ${selectedPack === pack.id && classes.active}`}
                    >
                      {pack.packCurrency +
                        " " +
                        pack.packPrice +
                        "/" +
                        t("pack" + pack.id + "_2")}
                    </p>
                  </button>
                ))}
              </div>

              <div className={classes.check_box_container}>
                <input
                  type="checkbox"
                  id="terms"
                  name="Terms & Conditions"
                  value="Terms"
                  className={classes.check_box}
                  checked
                  readOnly
                />
                <label className={classes.check_box_label}>
                  <a href="/tnc">
                    <span className={classes.terms_conditions}>
                      {t("privacy")}
                    </span>
                  </a>
                </label>
              </div>

              <button
                type="submit"
                disabled={loading}
                className={classes.login_btn}
              >
                {loading ? (
                  <SmallLoader style={{ border: "5px solid #fff" }} />
                ) : (
                  t("14")
                )}
              </button>
            </form>
          )}
        </Container>
      </SubLayout>
    </Layout>
  );
};

export default SubscribePage;
